import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "offcanvas-header border-bottom p-4" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "fs-18 fw-medium lh-base lh-sm mb-3" }
const _hoisted_7 = { class: "offcanvas-body p-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_10 = { class: "card-body p-4" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-12" }
const _hoisted_13 = { class: "row g-3" }
const _hoisted_14 = { class: "col-md-6 col-lg-4" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_17 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_20 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_23 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_26 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_29 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_32 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_33 = { key: 6 }
const _hoisted_34 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_35 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_36 = { key: 7 }
const _hoisted_37 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_38 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_39 = { key: 8 }
const _hoisted_40 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_41 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_42 = { key: 9 }
const _hoisted_43 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_44 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_45 = { key: 10 }
const _hoisted_46 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_47 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_48 = { key: 11 }
const _hoisted_49 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_50 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_51 = { key: 12 }
const _hoisted_52 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_53 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_54 = { key: 13 }
const _hoisted_55 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_56 = {
  class: "mb-0 fw-medium fs-14 position-relative ms-2",
  style: {"min-width":"200px","width":"100%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_57 = { key: 14 }
const _hoisted_58 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_59 = { class: "mb-0 fw-medium fs-14 position-relative ms-2" }
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_62 = { class: "card-body p-4" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-lg-12" }
const _hoisted_65 = { class: "row g-3" }
const _hoisted_66 = {
  class: "col-md-12 col-lg-12",
  style: {"min-width":"300px","overflow":"visible","text-overflow":"ellipsis"}
}
const _hoisted_67 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4"
}
const _hoisted_68 = { class: "card-body p-4" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-lg-12" }
const _hoisted_71 = { class: "row g-3" }
const _hoisted_72 = {
  class: "col-md-12 col-lg-12",
  style: {"min-width":"300px","overflow":"visible","text-overflow":"ellipsis"}
}
const _hoisted_73 = {
  key: 0,
  class: "custom-alert"
}
const _hoisted_74 = { class: "alert-content" }
const _hoisted_75 = { class: "alert-buttons" }
const _hoisted_76 = { class: "default-table-area style-two all-projects" }
const _hoisted_77 = { class: "table-responsive" }
const _hoisted_78 = { class: "table table-bordered table-striped- table-hover align-middle" }
const _hoisted_79 = { class: "table-light" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "material-symbols-outlined" }
const _hoisted_82 = { class: "clickable-column" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { key: 2 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 3,
  style: {"min-width":"100px"}
}
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 4 }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { key: 5 }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = {
  key: 6,
  style: {"width":"100px!important"}
}
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = {
  key: 7,
  class: "clickable-column"
}
const _hoisted_104 = { key: 0 }
const _hoisted_105 = ["src", "alt"]
const _hoisted_106 = {
  key: 8,
  class: "clickable-column"
}
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { key: 1 }
const _hoisted_110 = { key: 9 }
const _hoisted_111 = { class: "actions-column" }
const _hoisted_112 = { class: "d-flex align-items-center gap-1" }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = ["href"]
const _hoisted_115 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "position-relative table-src-form me-0" }, null, -1)),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass({'offcanvas offcanvas-end': true, 'show': _ctx.isOffcanvasVisible}),
          tabindex: "-1",
          style: {"min-width":"450px"},
          id: "offcanvasRight",
          "aria-labelledby": "offcanvasRightLabel"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (row, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.id
              }, [
                (row.id === _ctx.vacancyDetail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: _normalizeClass([ row.isActive ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger', 'd-inline-block py-1 px-3 rounded-3 mb-3'])
                      }, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-check-line fs-16 position-relative top-1" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(row.isActive ? 'активная' : 'закрытая'), 1)
                      ], 2),
                      _createElementVNode("h3", _hoisted_6, _toDisplayString(row.title), 1),
                      _createVNode(_component_RouterLink, {
                        to: `/vacancies/create/${row.id}`
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("i", {
                            class: "ri-clipboard-line fs-24 position-relative transition-all hover:text-primary-500 hover:scale-110",
                            title: "Копировать вакансию"
                          }, null, -1)
                        ])),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_RouterLink, {
                        to: `/candidates/create/${row.vacancyCandidates[0].id}`
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createElementVNode("i", {
                            class: "ri-user-add-line fs-24 position-relative transition-all hover:text-primary-500 hover:scale-110",
                            title: "Добавить кандидата"
                          }, null, -1)
                        ])),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeOffcanvas && _ctx.closeOffcanvas(...args))),
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (row, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.id
              }, [
                (row.id === _ctx.vacancyDetail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.vacancyCandidates, (position) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: position.id,
                          class: "vacancy-field-item"
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsDetails, (field) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: field.name,
                                          class: "vacancy-detail-item"
                                        }, [
                                          (field.name === 'position')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                  _cache[6] || (_cache[6] = _createElementVNode("span", {
                                                    class: "fw-bold",
                                                    style: {"min-width":"150px"}
                                                  }, "Должность:", -1)),
                                                  _createElementVNode("h5", _hoisted_17, _toDisplayString(position.position), 1)
                                                ])
                                              ]))
                                            : (field.name === 'rate')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                  _createElementVNode("div", _hoisted_19, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("span", {
                                                      class: "fw-bold",
                                                      style: {"min-width":"150px"}
                                                    }, "Ставка:", -1)),
                                                    _createElementVNode("h5", _hoisted_20, _toDisplayString(position.rate) + " zl", 1)
                                                  ])
                                                ]))
                                              : (field.name === 'age')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _createElementVNode("div", _hoisted_22, [
                                                      _cache[8] || (_cache[8] = _createElementVNode("span", {
                                                        class: "fw-bold",
                                                        style: {"min-width":"150px"}
                                                      }, "Возраст до:", -1)),
                                                      _createElementVNode("h5", _hoisted_23, _toDisplayString(position.age), 1)
                                                    ])
                                                  ]))
                                                : (field.name === 'schedule1')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                      _createElementVNode("div", _hoisted_25, [
                                                        _cache[9] || (_cache[9] = _createElementVNode("span", {
                                                          class: "fw-bold",
                                                          style: {"min-width":"150px"}
                                                        }, "График:", -1)),
                                                        _createElementVNode("h5", _hoisted_26, _toDisplayString(position.schedule1) + ", " + _toDisplayString(position.schedule2) + ", " + _toDisplayString(position.schedule3), 1)
                                                      ])
                                                    ]))
                                                  : (field.name === 'coordinatorId')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                        _createElementVNode("div", _hoisted_28, [
                                                          _cache[10] || (_cache[10] = _createElementVNode("span", {
                                                            class: "fw-bold",
                                                            style: {"min-width":"150px"}
                                                          }, "Координатор:", -1)),
                                                          _createElementVNode("h5", _hoisted_29, _toDisplayString(row.coordinator ? row.coordinator.name : 'N/A'), 1)
                                                        ])
                                                      ]))
                                                    : (field.name === 'coordinatorPhone')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                          _createElementVNode("div", _hoisted_31, [
                                                            _cache[11] || (_cache[11] = _createElementVNode("span", {
                                                              class: "fw-bold",
                                                              style: {"min-width":"150px"}
                                                            }, "Тел. коорд.:", -1)),
                                                            _createElementVNode("h5", _hoisted_32, _toDisplayString(row.coordinator ? row.coordinator.phone : 'N/A'), 1)
                                                          ])
                                                        ]))
                                                      : (field.name === 'quantity1')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                            _createElementVNode("div", _hoisted_34, [
                                                              _cache[12] || (_cache[12] = _createElementVNode("span", {
                                                                class: "fw-bold",
                                                                style: {"min-width":"150px"}
                                                              }, "Quantity1:", -1)),
                                                              _createElementVNode("h5", _hoisted_35, _toDisplayString(position.quantity1), 1)
                                                            ])
                                                          ]))
                                                        : (field.name === 'quantity2')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                              _createElementVNode("div", _hoisted_37, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("span", {
                                                                  class: "fw-bold",
                                                                  style: {"min-width":"150px"}
                                                                }, "Quantity2:", -1)),
                                                                _createElementVNode("h5", _hoisted_38, _toDisplayString(position.quantity2), 1)
                                                              ])
                                                            ]))
                                                          : (field.name === 'quantity3')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                                _createElementVNode("div", _hoisted_40, [
                                                                  _cache[14] || (_cache[14] = _createElementVNode("span", {
                                                                    class: "fw-bold",
                                                                    style: {"min-width":"150px"}
                                                                  }, "Quantity3:", -1)),
                                                                  _createElementVNode("h5", _hoisted_41, _toDisplayString(position.quantity3), 1)
                                                                ])
                                                              ]))
                                                            : (field.name === 'livingExists')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                  _createElementVNode("div", _hoisted_43, [
                                                                    _cache[15] || (_cache[15] = _createElementVNode("span", {
                                                                      class: "fw-bold",
                                                                      style: {"min-width":"150px"}
                                                                    }, "Living Exists:", -1)),
                                                                    _createElementVNode("h5", _hoisted_44, _toDisplayString(position.living_exists === 0 ? 'No' : 'Yes'), 1)
                                                                  ])
                                                                ]))
                                                              : (field.name === 'isActive')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                                    _createElementVNode("div", _hoisted_46, [
                                                                      _cache[16] || (_cache[16] = _createElementVNode("span", {
                                                                        class: "fw-bold",
                                                                        style: {"min-width":"150px"}
                                                                      }, "Is Active:", -1)),
                                                                      _createElementVNode("h5", _hoisted_47, _toDisplayString(row.isActive ? 'Yes' : 'No'), 1)
                                                                    ])
                                                                  ]))
                                                                : (field.name === 'isPriority')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                                      _createElementVNode("div", _hoisted_49, [
                                                                        _cache[17] || (_cache[17] = _createElementVNode("span", {
                                                                          class: "fw-bold",
                                                                          style: {"min-width":"150px"}
                                                                        }, "Is Priority:", -1)),
                                                                        _createElementVNode("h5", _hoisted_50, _toDisplayString(row.isPriority ? 'Yes' : 'No'), 1)
                                                                      ])
                                                                    ]))
                                                                  : (field.name === 'isMediator')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                                        _createElementVNode("div", _hoisted_52, [
                                                                          _cache[18] || (_cache[18] = _createElementVNode("span", {
                                                                            class: "fw-bold",
                                                                            style: {"min-width":"150px"}
                                                                          }, "Is Mediator:", -1)),
                                                                          _createElementVNode("h5", _hoisted_53, _toDisplayString(row.isMediator ? 'Yes' : 'No'), 1)
                                                                        ])
                                                                      ]))
                                                                    : (field.name === 'living')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                                          _createElementVNode("div", _hoisted_55, [
                                                                            _cache[19] || (_cache[19] = _createElementVNode("span", {
                                                                              class: "fw-bold",
                                                                              style: {"min-width":"150px"}
                                                                            }, "Адрес жилья:", -1)),
                                                                            _createElementVNode("h5", _hoisted_56, _toDisplayString(row.living), 1)
                                                                          ])
                                                                        ]))
                                                                      : (field.name === 'address')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                            _createElementVNode("div", _hoisted_58, [
                                                                              _cache[20] || (_cache[20] = _createElementVNode("span", {
                                                                                class: "fw-bold",
                                                                                style: {"min-width":"150px"}
                                                                              }, "Адрес:", -1)),
                                                                              _createElementVNode("h5", _hoisted_59, [
                                                                                _createTextVNode(_toDisplayString(position.city) + ", " + _toDisplayString(position.address) + " ", 1),
                                                                                _createElementVNode("a", {
                                                                                  href: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(position.city + ' ' + position.address),
                                                                                  target: "_blank",
                                                                                  rel: "noopener noreferrer"
                                                                                }, " (открыть карту)", 8, _hoisted_60)
                                                                              ])
                                                                            ])
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createTextVNode(_toDisplayString(position.description) + " ", 1),
                                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          (row.comment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", _hoisted_72, [
                                          _createTextVNode(_toDisplayString(row.comment) + " ", 1),
                                          _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 2), [
          [_vShow, _ctx.isOffcanvasVisible]
        ]),
        _createVNode(_component_RouterLink, {
          to: "/vacancies/create",
          class: "btn btn-outline-primary px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block" }),
              _createElementVNode("span", null, " Добавить вакансию ")
            ], -1)
          ])),
          _: 1
        })
      ]),
      (_ctx.deleteAlert.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "alert-message" }, "Подтвердите удаление", -1)),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger confirm-button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                }, " Подтвердить "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary cancel-button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                }, " Отменить ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("table", _hoisted_78, [
            _createElementVNode("thead", _hoisted_79, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: field.name,
                    scope: "col"
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.handleSortClick(field.name)),
                      class: "cursor-pointer d-flex justify-content-between align-items-center sortable-header"
                    }, [
                      _createTextVNode(_toDisplayString(field.label) + " ", 1),
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.getSortIcon(field.name)), 1)
                    ], 8, _hoisted_80)
                  ]))
                }), 128)),
                _cache[26] || (_cache[26] = _createElementVNode("th", {
                  scope: "col",
                  class: "actions-column"
                }, "Действия", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.id,
                  class: _normalizeClass(_ctx.getRowClass(row))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: field.name,
                      class: _normalizeClass({'max-width-column': field.name === 'number'})
                    }, [
                      _createElementVNode("div", _hoisted_82, [
                        (field.name === 'number')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.showDetails(row.id))
                            }, _toDisplayString(row.number), 9, _hoisted_83))
                          : (field.name === 'title')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.showDetails(row.id))
                              }, _toDisplayString(row.title), 9, _hoisted_84))
                            : (field.name === 'city')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  (row.vacancyCandidates && row.vacancyCandidates[0])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(row.vacancyCandidates[0].city), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (field.name === 'quantity')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.vacancyCandidates, (position, key) => {
                                      return (_openBlock(), _createElementBlock("div", { key: key }, [
                                        (_ctx.userRole==='coordinator_su' || _ctx.userRole==='coordinator_zl')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                              (position.is_active === 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                    _cache[27] || (_cache[27] = _createElementVNode("b", null, " М:", -1)),
                                                    _createTextVNode(_toDisplayString(position.quantity1 > 0 ? position.quantity1 : 0) + " ", 1),
                                                    _cache[28] || (_cache[28] = _createElementVNode("b", null, " Ж:", -1)),
                                                    _createTextVNode(_toDisplayString(position.quantity2 > 0 ? position.quantity2 : 0) + " ", 1),
                                                    _cache[29] || (_cache[29] = _createElementVNode("b", null, " П:", -1)),
                                                    _createTextVNode(_toDisplayString(position.quantity3 > 0 ? position.quantity3 : 0) + " ", 1),
                                                    _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                              _cache[31] || (_cache[31] = _createElementVNode("b", null, " М:", -1)),
                                              _createTextVNode(_toDisplayString(position.quantity1 > 0 ? position.quantity1 : 0) + " ", 1),
                                              _cache[32] || (_cache[32] = _createElementVNode("b", null, " Ж:", -1)),
                                              _createTextVNode(_toDisplayString(position.quantity2 > 0 ? position.quantity2 : 0) + " ", 1),
                                              _cache[33] || (_cache[33] = _createElementVNode("b", null, " П:", -1)),
                                              _createTextVNode(_toDisplayString(position.quantity3 > 0 ? position.quantity3 : 0) + " ", 1),
                                              _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1))
                                            ]))
                                      ]))
                                    }), 128))
                                  ]))
                                : (field.name === 'position')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.vacancyCandidates, (position, key) => {
                                        return (_openBlock(), _createElementBlock("div", { key: key }, [
                                          (_ctx.userRole==='coordinator_su' || _ctx.userRole==='coordinator_zl')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                                (position.is_active === 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                      _createElementVNode("b", null, _toDisplayString(position.position), 1),
                                                      _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                _createElementVNode("b", null, _toDisplayString(position.position), 1),
                                                _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1))
                                              ]))
                                        ]))
                                      }), 128))
                                    ]))
                                  : (field.name === 'rate')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.vacancyCandidates, (position, key) => {
                                          return (_openBlock(), _createElementBlock("div", { key: key }, [
                                            (_ctx.userRole==='coordinator_su' || _ctx.userRole==='coordinator_zl')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                  (position.is_active === 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                        _createTextVNode(" (" + _toDisplayString(position.rate) + " zl.) ", 1),
                                                        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                  _createTextVNode(" (" + _toDisplayString(position.rate) + " zl.) ", 1),
                                                  _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1))
                                                ]))
                                          ]))
                                        }), 128))
                                      ]))
                                    : (field.name === 'livingExists')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                          (row.vacancyCandidates && row.vacancyCandidates[0])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                (row.vacancyCandidates[0].livingExists == 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, "нет"))
                                                  : _createCommentVNode("", true),
                                                (row.vacancyCandidates[0].livingExists == 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, _toDisplayString(row.vacancyCandidates[0].livingPrice), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (field.name === 'nation')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                            (row.vacancyCandidates && row.vacancyCandidates[0])
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(row.vacancyCandidates[0].nation), (country) => {
                                                    return (_openBlock(), _createElementBlock("span", { key: country }, [
                                                      _createElementVNode("img", {
                                                        src: `/images/flags/${country.slice(0, 3)}.svg`,
                                                        alt: country,
                                                        width: "24",
                                                        height: "16"
                                                      }, null, 8, _hoisted_105),
                                                      _cache[39] || (_cache[39] = _createTextVNode("   "))
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (field.name === 'isArrival')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                              (row.vacancyCandidates && row.vacancyCandidates[0])
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                    _createElementVNode("span", null, _toDisplayString(row.vacancyCandidates[0].isArrival == '1' ? '' : 'Нет'), 1),
                                                    (row.vacancyCandidates[0].isArrival == '1')
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(row.vacancyCandidates[0].arrivalAddress), 1))
                                                      : _createCommentVNode("", true),
                                                    _cache[40] || (_cache[40] = _createTextVNode()),
                                                    _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
                                                    (row.vacancyCandidates[0].isArrival == '1')
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(row.vacancyCandidates[0].arrivalPrice) + " zl ", 1))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(row[field.name]), 1))
                      ])
                    ], 2))
                  }), 128)),
                  _createElementVNode("td", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.showDetails(row.id))
                      }, _cache[42] || (_cache[42] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility", -1)
                      ]), 8, _hoisted_113),
                      _createElementVNode("a", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        href: `/vacancies/edit/${row.id}`
                      }, _cache[43] || (_cache[43] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit", -1)
                      ]), 8, _hoisted_114),
                      (_ctx.userRole !== 'manager')
                        ? _withDirectives((_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                            onClick: ($event: any) => (_ctx.showDeleteConfirmation(row))
                          }, _cache[44] || (_cache[44] = [
                            _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                          ]), 8, _hoisted_115)), [
                            [_directive_permission, ['vacancy delete']]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}